import type { BusinessEntity, Drlp, EntityAddedBy, IndividualLicensee } from '../types/onboarding'
import { newId } from './ids'

export function createEmptyDrlp(): Drlp {
  return { id: newId('DRLP'), fullName: '', jobTitle: '', residentState: '', slLicenseNumber: '', npn: '', assignedStates: [] }
}

export function createEmptyIndividual(fields: Partial<IndividualLicensee> = {}): IndividualLicensee {
  return { id: newId('IND'), fullName: '', residentState: '', licenseNumber: '', npn: '', ...fields }
}

/** New entities start with one blank DRLP card (design manual p.5: at least one DRLP per entity). */
export function createEmptyEntity(addedBy: EntityAddedBy, fields: Partial<BusinessEntity> = {}): BusinessEntity {
  return {
    id: newId('ENT'),
    name: '',
    residentState: '',
    slLicenseNumber: '',
    npn: '',
    fein: '',
    addedBy,
    statesToHandle: [],
    drlps: [createEmptyDrlp()],
    individuals: [],
    individualsReviewed: false,
    writingBusiness: {},
    credentials: [],
    seededPortalIds: [],
    updatedAt: null,
    ...fields,
  }
}
